import type { SVGProps } from 'react'
const SvgCrossIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.00078 8.61074L2.10078 13.5107C1.91745 13.6941 1.68411 13.7857 1.40078 13.7857C1.11745 13.7857 0.884115 13.6941 0.700781 13.5107C0.517448 13.3274 0.425781 13.0941 0.425781 12.8107C0.425781 12.5274 0.517448 12.2941 0.700781 12.1107L5.60078 7.21074L0.700781 2.31074C0.517448 2.12741 0.425781 1.89408 0.425781 1.61074C0.425781 1.32741 0.517448 1.09408 0.700781 0.910742C0.884115 0.727409 1.11745 0.635742 1.40078 0.635742C1.68411 0.635742 1.91745 0.727409 2.10078 0.910742L7.00078 5.81074L11.9008 0.910742C12.0841 0.727409 12.3174 0.635742 12.6008 0.635742C12.8841 0.635742 13.1174 0.727409 13.3008 0.910742C13.4841 1.09408 13.5758 1.32741 13.5758 1.61074C13.5758 1.89408 13.4841 2.12741 13.3008 2.31074L8.40078 7.21074L13.3008 12.1107C13.4841 12.2941 13.5758 12.5274 13.5758 12.8107C13.5758 13.0941 13.4841 13.3274 13.3008 13.5107C13.1174 13.6941 12.8841 13.7857 12.6008 13.7857C12.3174 13.7857 12.0841 13.6941 11.9008 13.5107L7.00078 8.61074Z"
      fill="white"
    />
  </svg>
)
export default SvgCrossIcon
